import './Banner.css'
import { useEffect, useState } from 'react';
import DLScreator from '../../assets/DLScreator.png';
const Banner = () => {
  const [text, setText] = useState(null);

  useEffect(() => {
    fetch('https://dlskiturl.com/CardCreator/bodyText.json')
      .then(res => res.json())
      .then(setText);
  }, []);

  if (!text) return null; // or a loader
  return (
    <>
      <div className='banner'>
        <img src={DLScreator} />
      </div>
       <div className="container" style={{
        width:"100%",
        margin:"auto",
        textAlign:"left"
      }}>
      <h1 className="text-center my-3">{text.title}</h1>
        <p className="px-1"  dangerouslySetInnerHTML={{__html: text.para1}} />
        <p className="px-1"  dangerouslySetInnerHTML={{__html: text.para2}} />
      </div>
     <ins class="adsbygoogle"
     style={{"display":"block"}}
     data-ad-client="ca-pub-6615141629252034"
     data-ad-slot="9341265136"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins>

    </>
  )
}

export default Banner